/* Página «onde nos encontrar» — comportamento.
 *
 * Nota de arquitectura: este ficheiro NÃO traz dados. As lojas vêm escritas no
 * HTML pelo gerador (build_pagina_lojas.py) e é de lá que ele lê — dos atributos
 * data-* dos cartões e dos pinos. Foi de propósito: o Google tem de encontrar os
 * nomes e as moradas na página, não montados depois por JavaScript.
 */
(function () {
  "use strict";
  var raiz = document.querySelector(".ebh-lojas");
  if (!raiz) return;

  var $ = function (s) { return raiz.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(raiz.querySelectorAll(s)); };
  var criar = function (t, c) { var e = document.createElement(t); if (c) e.className = c; return e; };

  var cartoes = $$(".lista .loja");
  var paisEscolhido = null, tipoEscolhido = null, texto = "", seleccionada = null;

  /* ── índice a partir do próprio HTML ─────────────────────────────────── */
  var LOJAS = cartoes.map(function (c) {
    return {
      el: c,
      i: c.dataset.i,
      c: c.dataset.pais || "",
      pais: c.dataset.paisNome || "",
      tipo: c.dataset.tipo || "",
      online: c.dataset.online === "1",
      procura: c.textContent.toLowerCase(),
      nome: (c.querySelector(".nome") || {}).textContent || "",
      cid: c.dataset.cidade || ""
    };
  });
  var porIndice = {};
  LOJAS.forEach(function (l) { porIndice[l.i] = l; });

  /* ── mostrar / esconder cartões ──────────────────────────────────────── */
  function combina(l) {
    if (paisEscolhido && l.c !== paisEscolhido) return false;
    if (tipoEscolhido && l.tipo !== tipoEscolhido) return false;
    if (texto && l.procura.indexOf(texto) < 0) return false;
    return true;
  }

  function pintarLista() {
    var visiveis = 0;
    LOJAS.forEach(function (l) {
      var ok = combina(l);
      l.el.hidden = !ok;
      if (ok) visiveis++;
    });
    // um país sem cartões visíveis não mostra o seu título
    $$(".lista .grupo").forEach(function (g) {
      g.hidden = !g.querySelector(".loja:not([hidden])");
    });
    var v = $("#ebh-vazio");
    if (v) v.hidden = visiveis > 0;
    var t = $("#ebh-titulo");
    if (t) t.textContent = paisEscolhido ? (porPais(paisEscolhido) || t.dataset.todas)
      : (tipoEscolhido || t.dataset.todas);
    var lp = $("#ebh-limpar");
    if (lp) lp.hidden = !paisEscolhido;
  }
  function porPais(cod) {
    for (var i = 0; i < LOJAS.length; i++) if (LOJAS[i].c === cod) return LOJAS[i].pais;
    return "";
  }

  /* ── país escolhido no mapa ──────────────────────────────────────────── */
  function escolherPais(cod) {
    paisEscolhido = (paisEscolhido === cod) ? null : cod;
    fecharFicha();
    $(".mapas").classList.toggle("filtrado", !!paisEscolhido);
    $$(".pais.tem").forEach(function (p) {
      p.classList.toggle("escolhido", p.dataset.c === paisEscolhido);
    });
    $$(".pino").forEach(function (p) {
      p.classList.toggle("dentro", !paisEscolhido || p.dataset.pais === paisEscolhido);
    });
    var d = $("#ebh-destaque");
    if (d) d.hidden = !!paisEscolhido && paisEscolhido !== "PT";
    pintarLista();
    // escolher um país no mapa abre esse país na lista e fecha os outros
    if (paisEscolhido) $$(".lista .grupo").forEach(function (g) {
      g.open = g.dataset.pais === paisEscolhido;
    });
    var lista = $(".lista");
    if (paisEscolhido && lista) {
      var r = lista.getBoundingClientRect();
      if (r.top < 0 || r.top > innerHeight - 160)
        scrollTo({ top: scrollY + r.top - Math.max(60, innerHeight * 0.28), behavior: "smooth" });
    }
  }

  /* ── ficha em cima do mapa: clona o cartão que já está no HTML ───────── */
  var fichaAberta = null;
  function fecharFicha() {
    if (!fichaAberta) return;
    var f = fichaAberta; fichaAberta = null;
    f.classList.remove("aberta");
    setTimeout(function () { f.remove(); }, 200);
  }
  function abrirFicha(i, pino) {
    fecharFicha();
    var l = porIndice[i];
    if (!l) return;
    var c = criar("div", "ficha-mapa");
    c.innerHTML = l.el.innerHTML;
    var det = c.querySelector(".detalhe"); if (det) det.style.display = "grid";
    var x = criar("button", "fechar");
    x.type = "button"; x.setAttribute("aria-label", raiz.dataset.fechar || "Fechar"); x.textContent = "×";
    x.addEventListener("click", function (e) { e.stopPropagation(); fecharFicha(); });
    c.appendChild(x);
    var mapas = $(".mapas");
    mapas.appendChild(c);
    var rm = mapas.getBoundingClientRect(), rp = pino.getBoundingClientRect();
    var meia = c.offsetWidth / 2;
    var px = Math.min(Math.max(rp.left - rm.left + rp.width / 2, meia + 6), rm.width - meia - 6);
    var py = rp.top - rm.top - 10;
    if (py - c.offsetHeight < 0) py = rp.bottom - rm.top + c.offsetHeight + 10;
    c.style.left = px + "px"; c.style.top = py + "px";
    requestAnimationFrame(function () { c.classList.add("aberta"); });
    fichaAberta = c;
  }

  function escolherLoja(i, daLista) {
    seleccionada = (seleccionada === i) ? null : i;
    if (seleccionada) {
      var alvo = $$('.lista .loja[data-i="' + seleccionada + '"]')[0];
      var g = alvo && alvo.closest(".grupo");
      if (g) g.open = true;   /* senão o cartão fica escolhido dentro de um país fechado */
    }
    $$(".loja").forEach(function (c) { c.classList.toggle("activa", c.dataset.i === seleccionada); });
    $$(".pino").forEach(function (p) { p.classList.toggle("activo", p.dataset.i === seleccionada); });
    if (seleccionada === null) fecharFicha();
    else if (daLista) fecharFicha();
  }

  /* ── balão ───────────────────────────────────────────────────────────── */
  var balao = $("#ebh-balao");
  function mostrarBalao(txt, alvo, ev) {
    if (!balao) return;
    var m = $(".mapas").getBoundingClientRect();
    balao.textContent = txt;
    balao.classList.add("visivel");
    var x, y;
    if (ev) { x = ev.clientX - m.left; y = ev.clientY - m.top - 6; }
    else { var r = alvo.getBoundingClientRect(); x = r.left - m.left + r.width / 2; y = r.top - m.top; }
    var h = balao.offsetHeight, meia = balao.offsetWidth / 2;
    balao.style.left = Math.min(Math.max(x, meia + 4), m.width - meia - 4) + "px";
    balao.style.top = Math.min(Math.max(y, h * 1.5 + 4), m.height + h * 0.5 - 4) + "px";
  }
  function esconderBalao() { if (balao) balao.classList.remove("visivel"); }

  /* ── procura ─────────────────────────────────────────────────────────── */
  function procurar(valor, origem) {
    texto = (valor || "").trim().toLowerCase();
    $$("input[type=search]").forEach(function (e) { if (e !== origem) e.value = valor; });
    $(".mapas").classList.toggle("a-procurar", !!texto);
    $$(".pino").forEach(function (p) {
      var l = porIndice[p.dataset.i];
      p.classList.toggle("encontrado", !texto || (l && l.procura.indexOf(texto) >= 0));
    });
    mostrarResultados();
    pintarLista();
  }
  function mostrarResultados() {
    var caixa = $("#ebh-resultados");
    if (!caixa) return;
    caixa.textContent = "";
    if (!texto) { caixa.classList.remove("aberta"); return; }
    var achadas = LOJAS.filter(function (l) { return l.procura.indexOf(texto) >= 0; });
    if (!achadas.length) {
      var v = criar("p", "sem-resultado");
      v.textContent = caixa.dataset.nada || "";
      caixa.appendChild(v); caixa.classList.add("aberta"); return;
    }
    achadas.slice(0, 12).forEach(function (l) {
      var b = criar("button", "resultado"); b.type = "button";
      var img = l.el.querySelector(".retrato img");
      if (img) { var im = new Image(); im.src = img.currentSrc || img.src; im.alt = ""; b.appendChild(im); }
      var t = criar("div", "txt");
      var n = criar("div", "rn"); n.textContent = l.nome;
      var c = criar("div", "rc"); c.textContent = [l.cid, l.pais].filter(Boolean).join(" · ");
      t.appendChild(n); t.appendChild(c); b.appendChild(t);
      b.addEventListener("click", function (ev) {
        ev.stopPropagation();
        caixa.classList.remove("aberta");
        var pino = raiz.querySelector('.pino[data-i="' + l.i + '"]');
        if (pino) { escolherLoja(l.i, false); abrirFicha(l.i, pino); }
        else { l.el.scrollIntoView({ block: "center", behavior: "smooth" }); }
      });
      caixa.appendChild(b);
    });
    caixa.classList.add("aberta");
  }

  /* ── filtro por tipo ─────────────────────────────────────────────────── */
  $$(".tipo").forEach(function (b) {
    b.addEventListener("click", function () {
      var t = b.dataset.tipo || "";
      tipoEscolhido = (tipoEscolhido === t || !t) ? (t ? null : null) : t;
      if (!t) tipoEscolhido = null;
      $$(".tipo").forEach(function (x) {
        x.setAttribute("aria-pressed", String((x.dataset.tipo || "") === (tipoEscolhido || "")));
      });
      pintarLista();
    });
  });

  /* ── galeria da loja do Porto ────────────────────────────────────────── */
  (function galeria() {
    var g = $(".galeria"); if (!g) return;
    var imgs = Array.prototype.slice.call(g.querySelectorAll("img"));
    if (imgs.length < 2) return;
    var bolas = imgs.map(function (_, k) {
      var b = criar("button"); b.type = "button";
      b.setAttribute("aria-label", (g.dataset.foto || "Fotografia") + " " + (k + 1));
      b.setAttribute("aria-current", String(k === 0));
      b.addEventListener("click", function () { mostrar(k, true); });
      return b;
    });
    var pontos = criar("div", "pontos");
    bolas.forEach(function (b) { pontos.appendChild(b); });
    g.appendChild(pontos);
    var actual = 0, relogio = null;
    function mostrar(k, manual) {
      actual = (k + imgs.length) % imgs.length;
      imgs.forEach(function (im, i) { im.classList.toggle("visivel", i === actual); });
      bolas.forEach(function (b, i) { b.setAttribute("aria-current", String(i === actual)); });
      if (manual) recomecar();
    }
    function recomecar() {
      clearInterval(relogio);
      if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      relogio = setInterval(function () { mostrar(actual + 1); }, 4200);
    }
    mostrar(0); recomecar();
    g.addEventListener("mouseenter", function () { clearInterval(relogio); });
    g.addEventListener("mouseleave", recomecar);
  })();

  /* ── zoom dos mapas ──────────────────────────────────────────────────── */
  function ligarZoom(svg) {
    if (!svg) return;
    var moldura = svg.closest(".moldura");
    var base = svg.getAttribute("viewBox").split(" ").map(Number);
    var mundo = (svg.dataset.mundo || "0 0 1000 760").split(" ").map(Number);
    var raio = +(svg.dataset.raio || 7);
    var vx = base[0], vy = base[1], vw = base[2], vh = base[3];
    var MAX = 8, folga = 0.10;
    var MX = mundo[0] - mundo[2] * folga, MW = mundo[2] * (1 + 2 * folga);
    var MY = mundo[1] - mundo[3] * folga, MH = mundo[3] * (1 + 2 * folga);
    var MIN = Math.min(1, base[3] / MH);

    var cmd = criar("div", "zoom");
    function botao(txt, rot) {
      var b = criar("button"); b.type = "button"; b.textContent = txt;
      b.setAttribute("aria-label", rot); cmd.appendChild(b); return b;
    }
    var bMais = botao("+", svg.dataset.aproximar || "+");
    var bMenos = botao("−", svg.dataset.afastar || "−");
    var bRepor = botao("↺", svg.dataset.repor || "↺");
    moldura.appendChild(cmd);

    function escala() { return base[2] / vw; }
    function aplicar() {
      svg.setAttribute("viewBox", [vx, vy, vw, vh].join(" "));
      var e = escala();
      svg.querySelectorAll(".pino").forEach(function (p) {
        p.setAttribute("r", (p.classList.contains("nossa") ? raio * 1.5 : raio) / e);
      });
      svg.querySelectorAll(".anel").forEach(function (a) { a.setAttribute("r", raio * 2.4 / e); });
      svg.querySelectorAll(".etiqueta").forEach(function (t) { t.setAttribute("font-size", 20 / e); });
      moldura.classList.toggle("com-zoom", Math.abs(e - 1) > 0.02);
      bRepor.disabled = Math.abs(e - 1) <= 0.02;
      bMenos.disabled = e <= MIN + 0.005;
      bMais.disabled = e >= MAX - 0.01;
      fecharFicha();
    }
    function limitar() {
      vw = Math.min(base[2] / MIN, Math.max(base[2] / MAX, vw));
      vh = vw * base[3] / base[2];
      vx = vw >= MW ? MX + (MW - vw) / 2 : Math.min(MX + MW - vw, Math.max(MX, vx));
      vy = vh >= MH ? MY + (MH - vh) / 2 : Math.min(MY + MH - vh, Math.max(MY, vy));
    }
    function ampliar(f, px, py) {
      var r = svg.getBoundingClientRect();
      var ax = px === undefined ? 0.5 : (px - r.left) / r.width;
      var ay = py === undefined ? 0.5 : (py - r.top) / r.height;
      var aX = vx + vw * ax, aY = vy + vh * ay;
      vw /= f; vh /= f; vx = aX - vw * ax; vy = aY - vh * ay;
      limitar(); aplicar();
    }
    bMais.addEventListener("click", function () { ampliar(1.7); });
    bMenos.addEventListener("click", function () { ampliar(1 / 1.7); });
    bRepor.addEventListener("click", function () { vx = base[0]; vy = base[1]; vw = base[2]; vh = base[3]; aplicar(); });
    svg.addEventListener("dblclick", function (e) { e.preventDefault(); ampliar(2, e.clientX, e.clientY); });
    // a roda só aproxima com Ctrl/⌘: sem isso o mapa prendia quem passa a rolar
    svg.addEventListener("wheel", function (e) {
      if (!e.ctrlKey && !e.metaKey) return;
      e.preventDefault();
      ampliar(e.deltaY < 0 ? 1.2 : 1 / 1.2, e.clientX, e.clientY);
    }, { passive: false });

    var arr = null;
    svg.addEventListener("pointerdown", function (e) {
      if (escala() <= 1.02 || e.target.closest(".pino")) return;
      var r = svg.getBoundingClientRect();
      arr = { x: vx + (e.clientX - r.left) / r.width * vw,
              y: vy + (e.clientY - r.top) / r.height * vh, id: e.pointerId };
      svg.setPointerCapture(e.pointerId);
      moldura.classList.add("a-arrastar");
    });
    svg.addEventListener("pointermove", function (e) {
      if (!arr || e.pointerId !== arr.id) return;
      var r = svg.getBoundingClientRect();
      vx = arr.x - (e.clientX - r.left) / r.width * vw;
      vy = arr.y - (e.clientY - r.top) / r.height * vh;
      limitar();
      svg.setAttribute("viewBox", [vx, vy, vw, vh].join(" "));
    });
    function largar(e) {
      if (!arr) return;
      arr = null; moldura.classList.remove("a-arrastar");
      try { svg.releasePointerCapture(e.pointerId); } catch (_) { /* já libertado */ }
    }
    svg.addEventListener("pointerup", largar);
    svg.addEventListener("pointercancel", largar);

    var dist = 0;
    svg.addEventListener("touchstart", function (e) {
      if (e.touches.length === 2)
        dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                          e.touches[0].clientY - e.touches[1].clientY);
    }, { passive: true });
    svg.addEventListener("touchmove", function (e) {
      if (e.touches.length !== 2) return;
      e.preventDefault();
      var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX,
                         e.touches[0].clientY - e.touches[1].clientY);
      if (dist) ampliar(d / dist,
        (e.touches[0].clientX + e.touches[1].clientX) / 2,
        (e.touches[0].clientY + e.touches[1].clientY) / 2);
      dist = d;
    }, { passive: false });

    aplicar();
  }
  $$(".moldura > svg").forEach(ligarZoom);

  /* ── ligações ────────────────────────────────────────────────────────── */
  $$("input[type=search]").forEach(function (e) {
    e.addEventListener("input", function (ev) { procurar(ev.target.value, ev.target); });
  });
  var limpar = $("#ebh-limpar");
  if (limpar) limpar.addEventListener("click", function () { escolherPais(paisEscolhido); });

  raiz.addEventListener("mouseover", function (e) {
    var alvo = e.target.closest(".pino, .pais.tem");
    if (!alvo) return;
    if (alvo.classList.contains("pino")) {
      var l = porIndice[alvo.dataset.i];
      if (l) mostrarBalao(l.nome + " · " + l.cid, alvo);
    } else mostrarBalao(alvo.dataset.nome || "", alvo, e);
  });
  raiz.addEventListener("mousemove", function (e) {
    var p = e.target.closest(".pais.tem");
    if (p) mostrarBalao(p.dataset.nome || "", p, e);
  });
  raiz.addEventListener("mouseout", function (e) {
    if (e.target.closest(".pino, .pais.tem")) esconderBalao();
  });
  raiz.addEventListener("click", function (e) {
    var pino = e.target.closest(".pino");
    if (pino) {
      var i = pino.dataset.i;
      escolherLoja(i, false);
      if (seleccionada === i) abrirFicha(i, pino); else fecharFicha();
      return;
    }
    if (e.target.closest("summary")) return;   /* abrir o horário não é clicar no cartão */
    if (fichaAberta && !e.target.closest(".ficha-mapa")) fecharFicha();
    var res = $("#ebh-resultados");
    if (res && !e.target.closest(".busca-mapa") && !e.target.closest(".resultados"))
      res.classList.remove("aberta");
    var pais = e.target.closest(".pais.tem");
    if (pais) { escolherPais(pais.dataset.c); return; }
    var cartao = e.target.closest(".lista .loja, .pais-lojas .loja");
    if (cartao) escolherLoja(cartao.dataset.i, true);
  });
  raiz.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      fecharFicha();
      var r = $("#ebh-resultados"); if (r) r.classList.remove("aberta");
      return;
    }
    if (e.key !== "Enter" && e.key !== " ") return;
    var alvo = e.target.closest(".pino, .pais.tem");
    if (!alvo) return;
    e.preventDefault();
    if (alvo.classList.contains("pino")) {
      var i = alvo.dataset.i;
      escolherLoja(i, false);
      if (seleccionada === i) abrirFicha(i, alvo);
    } else escolherPais(alvo.dataset.c);
  });

  /* o horário dos sete dias está no HTML; mostra-se só o de hoje.
     O JS conta a semana a partir de domingo, a nossa lista começa à segunda. */
  var DIAS = ["seg", "ter", "qua", "qui", "sex", "sáb", "dom"];
  var hoje = DIAS[(new Date().getDay() + 6) % 7];
  var palavraHoje = raiz.dataset.hoje || "";
  $$(".hoje[data-dia]").forEach(function (e) {
    e.hidden = e.dataset.dia !== hoje;
    if (!e.hidden && palavraHoje) e.textContent = palavraHoje + " " + e.textContent;
  });

  $$(".pino").forEach(function (p) { p.classList.add("dentro", "encontrado"); });
  pintarLista();
})();
